export default "__VITE_ASSET__98813c44__"